<template>
    <div class="wrap">
        <div class="wrap_inner">
            <div class="wrap_main">
                <div class='mainlist' :style="{position:absolute,top:0,bottom:0,overflow:disShow?'hidden':'auto'}">
                    <div class="blk1">
                        <img src="./image/banner3@2x.png" style="position:absolute;top:0;left:0;width: 100%;height: 100%"></img>
                        <div class="blkps">
                            <div class="blkrect"></div>
                            <div class="txtku1">我的报修</div>
                        </div>
                        <div @click="goBack" class="imgp">
                            <van-icon name="arrow-left" />
                        </div>
                    </div>

                    <div>
                        <van-tabs color="#0080ff" @click="tabClick" @disabled="getsxData" class="ffxyzcSty">
                            <van-tab title="全部">
                                <div>
                                    <!-- <div class="txta">
                                        <div class="dfSty">
                                            <span class="txta1">{{day}}</span><span class="txta2">{{month}}月</span><span class="txta3">今天</span>
                                        </div>
                                    </div> -->
                                    <div v-if="dataList.length>0">
                                        <div ref="wrap" class="scroll_wrap">
                                            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                                                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false" :error.sync="error" error-text="请求失败，点击重新加载">
                                                    <!-- 列表区域 -->
                                                    <div v-for="(item,index) in dataList" :key="index">
                                                        <PJXQ :item="item" @close="getClose"></PJXQ>
                                                    </div>
                                                </van-list>
                                            </van-pull-refresh>
                                        </div>
                                    </div>
                                    <div v-else class="nData">暂无数据</div>
                                </div>
                            </van-tab>
                            <van-tab title="待响应">
                                <div>
                                    <div v-if="dataList3.length>0">
                                        <div ref="wrap" class="scroll_wrap">
                                            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                                                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData3" :immediate-check="false" :error.sync="error" error-text="请求失败，点击重新加载">
                                                    <!-- 列表区域 -->
                                                    <div v-for="(item,index) in dataList3" :key="index">
                                                        <PJXQ :item="item" @close="getClose"></PJXQ>
                                                    </div>
                                                </van-list>
                                            </van-pull-refresh>
                                        </div>

                                    </div>
                                    <div v-else class="nData">暂无数据</div>
                                </div>
                            </van-tab>
                            <van-tab title="响应中">
                                <div>
                                    <!-- <div class="txta">
                                        <div class="dfSty">
                                            <span class="txta1">{{day}}</span><span class="txta2">{{month}}月</span><span class="txta3">今天</span>
                                        </div>
                                    </div> -->
                                    <div v-if="dataList1.length>0">
                                        <div ref="wrap" class="scroll_wrap">
                                            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                                                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData1" :immediate-check="false" :error.sync="error" error-text="请求失败，点击重新加载">
                                                    <!-- 列表区域 -->
                                                    <div v-for="(item,index) in dataList1" :key="index">
                                                        <PJXQ :item="item" @close="getClose"></PJXQ>
                                                    </div>
                                                </van-list>
                                            </van-pull-refresh>
                                        </div>

                                    </div>
                                    <div v-else class="nData">暂无数据</div>
                                </div>
                            </van-tab>
                            <van-tab title="已完成">
                                <div>
                                    <!-- <div class="txta">
                                        <div class="dfSty">
                                            <span class="txta1">{{day}}</span><span class="txta2">{{month}}月</span><span class="txta3">今天</span>
                                        </div>
                                    </div> -->
                                    <div v-if="dataList2.length>0">
                                        <div ref="wrap" class="scroll_wrap">
                                            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                                                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData2" :immediate-check="false" :error.sync="error" error-text="请求失败，点击重新加载">
                                                    <!-- 列表区域 -->
                                                    <div v-for="(item,index) in dataList2" :key="index">
                                                        <PJXQ :item="item"></PJXQ>
                                                    </div>
                                                </van-list>
                                            </van-pull-refresh>
                                        </div>

                                    </div>
                                    <div v-else class="nData">暂无数据</div>
                                </div>
                            </van-tab>
                            <van-tab title="筛选" disabled>
                                <template #title>
                                    <van-icon name="bars" />筛选
                                </template>
                            </van-tab>
                            <div class="ffxyzc1" v-if="sxShow">
                                <van-form @submit="onSubmit" ref='formty' validate-trigger="onSubmit" :show-error-message="false">
                                    <div class="ffxyzcn1">
                                        <div class="ffxyzcn2">
                                            <div style="flex:1">
                                                <van-field readonly clickable name="datetimePicker" :value="value" label="开始时间" placeholder="开始时间" @click="showPicker = true" />
                                                <van-popup v-model="showPicker" position="bottom">
                                                    <van-datetime-picker type="date" @confirm="confirmPickerStartf" @cancel="showPicker = false" :formatter="eformatter" v-model="currentDatemy" />
                                                </van-popup>
                                            </div>
                                            <div style="flex:1">
                                                <van-field readonly clickable name="datetimePicker" :value="value1" label="结束时间" placeholder="结束时间" @click="showPickerf = true" />
                                                <van-popup v-model="showPickerf" position="bottom">
                                                    <van-datetime-picker type="date" @confirm="confirmPickerEndf" @cancel="showPickerf = false" :formatter="eformatter" v-model="currentDatemy" />
                                                </van-popup>
                                            </div>
                                        </div>
                                        <div class="ffxyzcn3">
                                            <van-button type="default" class="ffxyzcn3btn1" @click="sxCancel">取消</van-button>
                                            <van-button type="info" class="ffxyzcn3btn2" native-type="submit">确定</van-button>
                                        </div>
                                    </div>
                                </van-form>
                            </div>
                        </van-tabs>
                    </div>
                    <div class="ffxyzc2" v-if="sxShow"></div>
                    <!-- <div v-if="disShow" style="width:100%;height:100%;z-index:5000">
                        <div ref="dig" class="mtblks" style="position:absolute;top:0;left:0;width:100%;height:100%;z-index:5000;opacity: 0.95;background: #333333;">
                            <div class="dialogs1">
                                <div class="digtxt">确认关闭响应支持吗</div>
                                <div class="txtx" @click="reback"><img src="./image/x@2x.png" style="position:absolute;top:0;right:0;width:100%;height:100%"></img></div>
                                <div class="c" style="display:flex;align-items:center;justify-content:center">
                                    <div class="reback" @click="reback">返回</div>
                                    <div class="submit" @click="submit1">确定</div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <customToast :toastRow="toastRow" :show="toastFlag"></customToast>
                    <van-dialog v-model:show="disShow" @cancel="reback" @confirm="submit1" confirm-button-color="#108EE9" show-cancel-button>
                        <div class="digtxt3">
                            <img src="../../components/image/error.png" alt="" style="width: 35%;padding-top: 25px;">
                            <div style="padding: 20px 0;">确认关闭响应支持</div>
                            <!-- <van-field v-model="reasons" style="border:1px solid #eee" rows="3" autosize type="textarea" placeholder="请输入关闭原因" /> -->
                        </div>
                    </van-dialog>
                </div>

            </div>
        </div>
    </div>

</template>
<script>
import customToast from "@/components/toast.vue";
import PJXQ from "@/components/mypjxq.vue";
export default {
    components: { PJXQ, customToast },
    data() {
        return {
            toastFlag: false,
            toastRow: {},
            error: false,
            loading: false,
            finished: false,
            refreshing: false,
            qureyFrom: {
                pageNum: 1,
                pageSize: 50,
            },
            ffname: 0,
            sxShow: false,
            value: "",
            value1: "",
            currentDatemy: new Date(),
            showPicker: false,
            showPickerf: false,
            day: "",
            month: "",
            dataList: [],
            dataList1: [],
            dataList3: [],
            dataList2: [],
            dataList4: [],
            dataListt: [],
            selected: "2",
            content1: [
                {
                    id: 1,
                    value: "",
                },
            ],
            content2: [
                {
                    id: 1,
                    value: "",
                },
            ],
            content3: [
                {
                    id: 1,
                    value: "",
                },
            ],
            itemList: [
                {
                    id: "1",
                    tit: "",
                    subtit: "",
                },
                {
                    id: "2",
                    tit: "",
                    subtit: "",
                },
                {
                    id: "3",
                    tit: "",
                    subtit: "",
                },
                {
                    id: "4",
                    tit: "",
                    subtit: "",
                },
            ],
            failItem: [],
            disShow: false,
        };
    },
    created() {
        var date = new Date();
        this.month = date.getMonth() + 1;
        this.day = date.getDate();
        this.getData();
        // this.getlevelData()
    },
    methods: {
        //请求失败
        requestErr() {
            this.loading = false;
            this.refreshing = false;
            this.error = true;
        },
        // 上拉刷新
        onRefresh() {
            this.finished = false;
            this.loading = true;
            this.qureyFrom.pageNum = 1;
            this.dataList = [];
            this.dataList3 = [];
            this.dataList1 = [];
            this.dataList2 = [];
            this.getData();
            this.getData3();
            this.getData1();
            this.getData2();
        },
        msToDate(time) {
            let datetime = new Date(time);
            let year = datetime.getFullYear();
            let month = datetime.getMonth();
            let date = datetime.getDate();
            let hour = datetime.getHours();
            let minute = datetime.getMinutes();
            let second = datetime.getSeconds();
            let result1 =
                year +
                "-" +
                (month + 1 >= 10 ? month + 1 : "0" + (month + 1)) +
                "-" +
                (date + 1 <= 10 ? "0" + date : date) +
                " " +
                (hour + 1 <= 10 ? "0" + hour : hour) +
                ":" +
                (minute + 1 <= 10 ? "0" + minute : minute) +
                ":" +
                (second + 1 <= 10 ? "0" + second : second);

            let result2 =
                year +
                "-" +
                (month + 1 >= 10 ? month + 1 : "0" + (month + 1)) +
                "-" +
                (date + 1 <= 10 ? "0" + date : date);
            let result = {
                hasTime: result1, // ---> 2017-09-19 08:00:00
                withoutTime: result2, // ---> 2017-09-19
            };
            return result;
        },
        getsxData() {
            this.sxShow = !this.sxShow;
            this.value = "";
            this.value1 = "";
            this.error = false;
            this.loading = false;
            // this.finished = false;
            this.refreshing = false;
            this.qureyFrom = {
                pageNum: 1,
                pageSize: 50,
            };
        },
        sxCancel() {
            this.sxShow = false;
            this.value = "";
            this.value1 = "";
        },
        //结束时间选择器确认按钮触发事件,根据是否被选中的条件渲染当前时间或被选中的结束时间
        confirmPickerEndf(val) {
            this.value1 = this.msToDate(val).withoutTime;
            //用户先选择开始时间时取两者的值进行比较判断
            if (new Date(this.value) > new Date(this.value1)) {
                // this.$toast("结束日期不能在开始日期之前");
                this.toastRow = {
                    selId: 4,
                    title: "结束日期不能在开始日期之前",
                    text: "结束日期不能在开始日期之前",
                };
                this.toastFlag = true;
                        setTimeout(() => {
                            this.toastFlag = false;
                        }, 1500);
            } else {
                this.showPickerf = false;
            }
        },
        confirmPickerStartf(val) {
            this.value = this.msToDate(val).withoutTime;
            //用户先选择结束时间时取两者的值进行比较判断
            if (new Date(this.value) > new Date(this.value1)) {
                // this.$toast("结束日期不能在开始日期之前");
                this.toastRow = {
                    selId: 4,
                    title: "结束日期不能在开始日期之前",
                    text: "结束日期不能在开始日期之前",
                };
                this.toastFlag = true;
                        setTimeout(() => {
                            this.toastFlag = false;
                        }, 1500);
            } else {
                this.showPicker = false;
            }
        },
        onSubmit() {
            if (this.value || this.value1) {
                this.$refs.formty
                    .validate()
                    .then(() => {
                        if (this.ffname == 0) {
                            this.dataList = [];
                            this.getData(this.value, this.value1);
                            this.sxShow = false;
                            this.value = "";
                            this.value1 = "";
                        } else if (this.ffname == 1) {
                            this.dataList3 = [];
                            this.getData3(this.value, this.value1);
                            this.sxShow = false;
                            this.value = "";
                            this.value1 = "";
                        } else if (this.ffname == 2) {
                            this.dataList1 = [];
                            this.getData1(this.value, this.value1);
                            this.sxShow = false;
                            this.value = "";
                            this.value1 = "";
                        } else if (this.ffname == 3) {
                            this.dataList2 = [];
                            this.getData2(this.value, this.value1);
                            this.sxShow = false;
                            this.value = "";
                            this.value1 = "";
                        }
                    })
                    .catch(() => {});
            } else {
                // this.$toastf("请选择开始时间或结束时间");
                this.toastRow = {
                    selId: 4,
                    title: "请选择开始时间或结束时间",
                    text: "请选择开始时间或结束时间",
                };
                this.toastFlag = true;
                        setTimeout(() => {
                            this.toastFlag = false;
                        }, 1500);
            }
        },
        tabClick(val) {
            this.currentDatemy = new Date();
            this.ffname = name;
            this.sxShow = false;
            (this.error = false),
                (this.loading = false),
                (this.finished = false),
                (this.refreshing = false),
                (this.qureyFrom = {
                    pageNum: 1,
                    pageSize: 50,
                });
            this.ffname = val;
            if (val == 0) {
                this.dataList = [];
                this.getData();
            } else if (val == 1) {
                this.dataList3 = [];
                this.getData3();
            } else if (val == 2) {
                this.dataList1 = [];
                this.getData1();
            } else if (val == 3) {
                this.dataList2 = [];
                this.getData2();
            }
        },
        reback() {
            this.disShow = false;
        },
        submit1() {
            let data = { recordId: this.recordId1 };
            this.$api
                .get("/app/support/deleteSupport", { params: data })
                .then((res) => {
                    if (res.data.code == "0000") {
                        // this.$toasts("关闭成功");
                        this.toastRow = {
                            selId: 3,
                            title: "关闭成功",
                            text: "您已成功关闭相应支持",
                        };
                        this.toastFlag = true;
                        setTimeout(() => {
                            this.toastFlag = false;
                        }, 1500);
                        this.error = false;
                        this.loading = false;
                        this.finished = false;
                        this.refreshing = false;
                        (this.qureyFrom = {
                            pageNum: 1,
                            pageSize: 50,
                        }),
                            (this.dataList = []);
                        this.dataList1 = [];
                        this.disShow = false;
                        this.getData();
                        this.getData1();
                    }
                });
        },
        getClose(data1, data2) {
            this.disShow = data1 == 1 ? true : false;
            this.recordId1 = data2;
        },
        getlevelData() {
            let data = { dictType: 1 };
            this.$api
                .get("/appConfigDictData/selectConfig", { params: data })
                .then((res) => {
                    if (res.data.code == "0000") {
                        this.failItem = res.data.data;
                        this.getData();
                        this.getData1();
                        this.getData2();
                        this.getData3();
                    } else if (res.data.code == "9999") {
                        // this.$toast(res.data.message);
                        this.toastRow = {
                            selId: 5,
                            title: res.data.message,
                            text: res.data.message,
                        };
                        this.toastFlag = true;
                        setTimeout(() => {
                            this.toastFlag = false;
                        }, 1500);
                    }
                });
        },
        goBack() {
            this.$router.push("/mine");
        },
        getData(st, et) {
            this.finished = false;
            if (st && et) {
                var data = {
                    userId: this.$store.state.user.userInfo.userId,
                    startTime: st,
                    endTime: et,
                    pageNum: this.qureyFrom.pageNum,
                    pageSize: this.qureyFrom.pageSize,
                };
            } else if (st && !et) {
                var data = {
                    userId: this.$store.state.user.userInfo.userId,
                    startTime: st,
                    endTime: null,
                    pageNum: this.qureyFrom.pageNum,
                    pageSize: this.qureyFrom.pageSize,
                };
            } else if (!st && et) {
                var data = {
                    userId: this.$store.state.user.userInfo.userId,
                    startTime: null,
                    endTime: et,
                    pageNum: this.qureyFrom.pageNum,
                    pageSize: this.qureyFrom.pageSize,
                };
            } else {
                var data = {
                    userId: this.$store.state.user.userInfo.userId,
                    pageNum: this.qureyFrom.pageNum,
                    pageSize: this.qureyFrom.pageSize,
                };
            }
            this.$api
                .post("/app/support/getSupportRecordListByUserId", data)
                .then((res) => {
                    if (res.data.code == "0000") {
                        this.qureyFrom.pageNum++;
                        if (this.refreshing) {
                            this.data = [];
                            this.refreshing = false;
                        }
                        const { datalist, count } = res.data.data;
                        this.dataList = this.dataList.concat(datalist);
                        this.loading = false;
                        if (this.dataList.length >= count) {
                            this.finished = true; //已全部请求完毕
                        }
                    } else {
                        this.dataList = [];
                        this.requestErr();
                    }
                })
                .catch((err) => {
                    this.requestErr();
                });
        },
        getData1(st, et) {
            this.finished = false;
            if (st && et) {
                var data1 = {
                    userId: this.$store.state.user.userInfo.userId,
                    recordStatus: 1,
                    startTime: st,
                    endTime: et,
                    pageNum: this.qureyFrom.pageNum,
                    pageSize: this.qureyFrom.pageSize,
                };
            } else if (st && !et) {
                var data1 = {
                    userId: this.$store.state.user.userInfo.userId,
                    recordStatus: 1,
                    startTime: st,
                    endTime: null,
                    pageNum: this.qureyFrom.pageNum,
                    pageSize: this.qureyFrom.pageSize,
                };
            } else if (!st && et) {
                var data1 = {
                    userId: this.$store.state.user.userInfo.userId,
                    recordStatus: 1,
                    startTime: null,
                    endTime: et,
                    pageNum: this.qureyFrom.pageNum,
                    pageSize: this.qureyFrom.pageSize,
                };
            } else {
                var data1 = {
                    userId: this.$store.state.user.userInfo.userId,
                    recordStatus: 1,
                    pageNum: this.qureyFrom.pageNum,
                    pageSize: this.qureyFrom.pageSize,
                };
            }

            this.$api
                .post("/app/support/getSupportRecordListByUserId", data1)
                .then((res) => {
                    if (res.data.code == "0000") {
                        this.qureyFrom.pageNum++;
                        if (this.refreshing) {
                            this.data = [];
                            this.refreshing = false;
                        }
                        const { datalist, count } = res.data.data;
                        this.dataList1 = this.dataList1.concat(datalist);
                        this.loading = false;
                        if (this.dataList1.length >= count) {
                            this.finished = true; //已全部请求完毕
                        }
                    } else {
                        this.dataList1 = [];
                        this.requestErr();
                    }
                })
                .catch((err) => {
                    this.requestErr();
                });
        },
        getData2(st, et) {
            this.finished = false;
            if (st && et) {
                var data2 = {
                    userId: this.$store.state.user.userInfo.userId,
                    recordStatus: 4,
                    startTime: st,
                    endTime: et,
                    pageNum: this.qureyFrom.pageNum,
                    pageSize: this.qureyFrom.pageSize,
                };
            } else if (st && !et) {
                var data2 = {
                    userId: this.$store.state.user.userInfo.userId,
                    recordStatus: 4,
                    startTime: st,
                    endTime: null,
                    pageNum: this.qureyFrom.pageNum,
                    pageSize: this.qureyFrom.pageSize,
                };
            } else if (!st && et) {
                var data2 = {
                    userId: this.$store.state.user.userInfo.userId,
                    recordStatus: 4,
                    startTime: null,
                    endTime: et,
                    pageNum: this.qureyFrom.pageNum,
                    pageSize: this.qureyFrom.pageSize,
                };
            } else {
                var data2 = {
                    userId: this.$store.state.user.userInfo.userId,
                    recordStatus: 4,
                    pageNum: this.qureyFrom.pageNum,
                    pageSize: this.qureyFrom.pageSize,
                };
            }
            this.$api
                .post("/app/support/getSupportRecordListByUserId", data2)
                .then((res) => {
                    if (res.data.code == "0000") {
                        this.qureyFrom.pageNum++;
                        if (this.refreshing) {
                            this.data = [];
                            this.refreshing = false;
                        }
                        const { datalist, count } = res.data.data;
                        this.dataList2 = this.dataList2.concat(datalist);
                        this.loading = false;
                        if (this.dataList2.length >= count) {
                            this.finished = true; //已全部请求完毕
                        }
                    } else {
                        this.dataList2 = [];
                        this.requestErr();
                    }
                })
                .catch((err) => {
                    this.requestErr();
                });
        },
        getData3(st, et) {
            this.finished = false;
            if (st && et) {
                var data3 = {
                    userId: this.$store.state.user.userInfo.userId,
                    recordStatus: 0,
                    startTime: st,
                    endTime: et,
                    pageNum: this.qureyFrom.pageNum,
                    pageSize: this.qureyFrom.pageSize,
                };
            } else if (st && !et) {
                var data3 = {
                    userId: this.$store.state.user.userInfo.userId,
                    recordStatus: 0,
                    startTime: st,
                    endTime: null,
                    pageNum: this.qureyFrom.pageNum,
                    pageSize: this.qureyFrom.pageSize,
                };
            } else if (!st && et) {
                var data3 = {
                    userId: this.$store.state.user.userInfo.userId,
                    recordStatus: 0,
                    startTime: null,
                    endTime: et,
                    pageNum: this.qureyFrom.pageNum,
                    pageSize: this.qureyFrom.pageSize,
                };
            } else {
                var data3 = {
                    userId: this.$store.state.user.userInfo.userId,
                    recordStatus: 0,
                    pageNum: this.qureyFrom.pageNum,
                    pageSize: this.qureyFrom.pageSize,
                };
            }
            this.$api
                .post("/app/support/getSupportRecordListByUserId", data3)
                .then((res) => {
                    if (res.data.code == "0000") {
                        this.qureyFrom.pageNum++;
                        if (this.refreshing) {
                            this.data = [];
                            this.refreshing = false;
                        }
                        const { datalist, count } = res.data.data;
                        this.dataList3 = this.dataList3.concat(datalist);
                        this.loading = false;
                        if (this.dataList3.length >= count) {
                            this.finished = true; //已全部请求完毕
                        }
                    } else {
                        this.dataList3 = [];
                        this.requestErr();
                    }
                })
                .catch((err) => {
                    this.requestErr();
                });
        },
    },
};
</script>
<style scoped>
::v-deep .van-dialog {
    width: 75% !important;
}
::v-deep .van-field__value {
    overflow: auto;
}
::v-deep .van-field {
    max-height: 200px;
    height: auto !important;
}
.digtxt3 {
    width: 80%;
    margin: 0 auto;
    padding: 20px 0;
    /* margin-bottom: 54px; */
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
}
.dialogs1 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 285px;
    height: 189px;
    background: #fff;
    border-radius: 8px;
    z-index: 1000;
}
.digtxt {
    width: 200px;
    height: 28px;
    margin: 34px auto;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
}
.digtxt1 {
    width: 200px;
    height: 28px;
    margin: 24px auto;
    margin-bottom: 54px;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
}
.txtx {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 12px;
    height: 12px;
    flex: 1;
}
.reback {
    flex: 0 0 100px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: #ffffff;
    border: 2px solid #0080ff;
    border-radius: 23px;
    color: #0080ff;
    font-size: 18px;
}
.submit {
    flex: 0 0 100px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: linear-gradient(140deg, #36b3fe 4%, #0080ff 96%);
    border-radius: 23px;
    color: #fff;
    font-size: 18px;
    margin-left: 20px;
}
.wrap {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2000;
    width: 100%;
    height: 100%;
    overflow: auto;
    background: #e9eef2;
    overflow-x: hidden;
}
.wrap_inner {
    min-height: 100%;
    width: 100%;
}
.wrap_main {
    position: absolute;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-bottom: 0px;
}
.mainlist {
    width: 100%;
    height: 100%;
}
.mainSty {
    width: 303px;
    height: 300x;
    padding: 14px 21px;
    margin: 0 auto;
    border-radius: 4px;
    box-shadow: 0px 3px 6px 0px rgba(16, 82, 139, 0.16);
    background: #fff;
}
.nData {
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
}
/deep/ .van-tab {
    color: #999999;
}
/deep/ .van-tab--active {
    color: #0080ff;
}
.blkm {
    width: 100%;
    height: 148px;
    background: linear-gradient(48deg, #36b3fe, #0080ff 89%);
}
.txta {
    width: 335px;
    height: 80px;
    line-height: 80px;
    margin-left: 20px;
}
.txta1 {
    display: inline-block;
    font-size: 38px;
    font-weight: 800;
}
.imgp {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 10px;
    left: 14px;
    width: 10px;
    height: 14px;
    color: #fff;
    font-size: 25px;
}
.txta2 {
    display: inline-block;
    font-size: 14px;
    font-weight: 400;
}
.txta3 {
    display: inline-block;
    font-size: 14px;
    font-weight: 400;
}
.dfSty {
    display: flex;
}
.blk1 {
    position: relative;
    width: 100%;
    height: 148px;
}
.blkps {
    position: absolute;
    top: 48px;
    right: 52px;
    width: 90px;
    height: 90px;
}
.blkrect {
    width: 20px;
    height: 2px;
    background: #ffffff;
}
.txtku1 {
    margin: 4px 0 10px 0;
    font-size: 20px;
    font-weight: 800;
    text-align: left;
    color: #ffffff;
}
.dialogs1 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 285px;
    height: 189px;
    background: #fff;
    border-radius: 8px;
    z-index: 1000;
}
.digtxt {
    width: 200px;
    height: 28px;
    margin: 34px auto;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
}
.digtxt1 {
    width: 200px;
    height: 28px;
    margin: 24px auto;
    margin-bottom: 54px;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
}
.txtx {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 12px;
    height: 12px;
    flex: 1;
}
.reback {
    flex: 0 0 100px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: #ffffff;
    border: 2px solid #0080ff;
    border-radius: 23px;
    color: #0080ff;
    font-size: 18px;
}
.submit {
    flex: 0 0 100px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: linear-gradient(140deg, #36b3fe 4%, #0080ff 96%);
    border-radius: 23px;
    color: #fff;
    font-size: 18px;
    margin-left: 20px;
}
.wrap {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    overflow: auto;
    background: #e9eef2;
    overflow-x: hidden;
}
.wrap_inner {
    min-height: 100%;
    width: 100%;
}
.wrap_main {
    position: absolute;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-bottom: 50px;
}
.mainlist {
    width: 100%;
    height: 100%;
}
.mainSty {
    width: 303px;
    height: 300x;
    padding: 14px 21px;
    margin: 0 auto;
    border-radius: 4px;
    box-shadow: 0px 3px 6px 0px rgba(16, 82, 139, 0.16);
    background: #fff;
}
.nData {
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
}
/deep/ .van-tab {
    color: #999999;
}
/deep/ .van-tab--active {
    color: #0080ff;
}
.blkm {
    width: 100%;
    height: 148px;
    background: linear-gradient(48deg, #36b3fe, #0080ff 89%);
}
.txta {
    width: 335px;
    height: 80px;
    line-height: 80px;
    margin-left: 20px;
}
.txta1 {
    display: inline-block;
    font-size: 38px;
    font-weight: 800;
}
.imgp {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 10px;
    left: 14px;
    width: 10px;
    height: 14px;
    color: #fff;
    font-size: 25px;
}
.txta2 {
    display: inline-block;
    font-size: 14px;
    font-weight: 400;
}
.txta3 {
    display: inline-block;
    font-size: 14px;
    font-weight: 400;
}
.dfSty {
    display: flex;
}
.blk1 {
    position: relative;
    width: 100%;
    height: 148px;
    z-index: 4000;
}
.blkps {
    position: absolute;
    top: 48px;
    right: 52px;
    width: 90px;
    height: 90px;
}
.blkrect {
    width: 20px;
    height: 2px;
    background: #ffffff;
}
.txtku1 {
    margin: 4px 0 10px 0;
    font-size: 20px;
    font-weight: 800;
    text-align: left;
    color: #ffffff;
}
.ffxyzcSty /deep/ .van-tabs__wrap--scrollable .van-tab {
    padding: 0;
}
.ffxyzcSty /deep/ .van-tabs__nav--line {
    z-index: 4000;
}
.ffxyzcSty /deep/ .van-cell {
    padding: 0 5px 0 5px !important;
    box-sizing: border-box;
}

.ffxyzcSty /deep/ .van-cell__value {
    height: 32px;
    padding: 6px 8px;
    box-sizing: border-box;
    line-height: 20px;
    border: 1px solid #bfbfbf;
    border-radius: 4px;
    color: #0080ff;
}
/deep/ .van-tabs__wrap {
    width: 100%;
}
/deep/ .van-tab--disabled {
    color: #0080ff;
    border-left: 1px solid #bfbfbf;
}
.ffxyzc1 {
    display: flex;
    position: absolute;
    top: 44px;
    left: 0;
    width: 100%;
    height: 99px;
    background: #fff;
    border-radius: 0px 0px 8px 8px;
    z-index: 4000;
}
.ffxyzc1 /deep/ .van-field__label {
    box-sizing: border-box;
    width: 65px;
    padding: 0 0px 0 0px;
    line-height: 32px;
    margin-right: 0;
}

.ffxyzcn1 {
    flex-direction: column;
    width: 100%;
    height: 100%;
    display: flex;
    padding: 0px 0px 0 0px;
    box-sizing: border-box;
}
.ffxyzcn2 {
    width: 100%;
    height: 62px;
    display: flex;
    padding: 12px;
    box-sizing: border-box;
}
.ffxyzcn3 {
    width: 100%;
    height: 37px;
    display: flex;
    box-sizing: border-box;
}
.ffxyzcn3btn1 {
    width: 50%;
    height: 37px;
    border-radius: 0px 0px 0px 8px;
    font-size: 16px;
}
.ffxyzcn3btn2 {
    width: 50%;
    height: 37px;
    background: linear-gradient(45deg, #36b3fe 3%, #0080ff 99%);
    border-radius: 0px 0px 8px 0px;
    font-size: 16px;
}
.ffxyzc2 {
    display: flex;
    position: absolute;
    top: 0px;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    opacity: 0.95;
    background: #333333;
    z-index: 3000;
}
</style>
